import styled from "styled-components";
import { IconButton, Input, NumberInput, Tooltip as TooltipUI } from "@evergis/ui";
import { TOOLTIP_DELAY_XY } from "../../../Classification/components/InputsAndValues/components/NonEditableField/NonEditableField";
import { SymbolButton } from "../../../../modules/SymbolLibrary/styled";

export const SymbolsContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
`;

export const Symbols = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  max-width: 14rem;
  overflow: hidden;

  ${SymbolButton} {
    margin: -10px 0 -5px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const SymbolsDescription = styled.div`
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme: { palette } }) => palette.textSecondary};
  margin-top: 0.25rem;
`;

export const Container = styled.span`
  display: flex;
  flex-direction: column;
  padding-bottom: 1.5rem;
  flex-shrink: 0;
`;

export const ClassificationIconButton = styled(IconButton)<{ fixedWidth?: boolean }>`
  width: ${({ fixedWidth }) => fixedWidth && "2rem"};
`;

ClassificationIconButton.defaultProps = {
  kind: "classification",
};

export const Units = styled.span`
  color: ${({ theme: { input } }) => input.placeholderColor};
`;

export const Tooltip = styled(TooltipUI)``;

Tooltip.defaultProps = {
  flip: false,
  distance: 8,
  arrow: true,
  placement: "top",
  delay: TOOLTIP_DELAY_XY,
};

export const ClassifiedInput = styled(Input)`
  ~ span:nth-child(3) {
    pointer-events: none;
  }
`;

export const NumberClassifierInput = styled(NumberInput)`
  padding-right: 4.25rem;

  ~ span:nth-child(2) {
    width: 1.6rem;
    min-width: 1.6rem;

    ${ClassificationIconButton} {
      width: 1.6rem;
    }
  }
  ~ div:nth-child(3) {
    right: 1.6rem;
  }
  ~ span:nth-child(4) {
    min-width: 1.1rem;
    width: 1.1rem;
    right: 3.1rem;
    display: flex;
    justify-content: start;
    pointer-events: none;
  }
`;

NumberClassifierInput.defaultProps = {
  counter: true,
  compact: true,
};
